import React from 'react';
import { GeoJSON, Popup } from 'react-leaflet';
import { OBSTACLE_COLORS } from 'views/RoutePlanner/ObstaclePlanner';
import { obstacleData } from 'views/Obstacles/MBObstacles';

interface ObstaclesProps {
  obstacles: any[] | null | undefined;
}

export const Obstacles = ({ obstacles }: ObstaclesProps) => {
  if (!obstacles || obstacles.length === 0) {
    return null;
  }

  return (
    <>
      {obstacles.map(ob => {
        const color = OBSTACLE_COLORS[ob.groundRisk] || 'red';
        return (
          <GeoJSON
            data={ob.geoJson}
            style={{
              color,
              weight: 2,
              fillOpacity: 0.5
            }}
            key={ob.name + 'mapObstacle' + ob.id}
          >
            <Popup>
              <div>
                <strong>Type:</strong> {obstacleData[ob.groundRisk].key}<br />
                {ob.name && (
                  <>
                    <strong>Name:</strong> {ob.name}<br />
                  </>
                )}
              </div>
            </Popup>
          </GeoJSON>
        );
      })}
    </>
  );
};

export default Obstacles;


